module.exports = __webpack_public_path__ + "img/code.97f0d83a.jpg";